import { Paper, Typography } from "@mui/material";
import { BoxFR } from "./BoxCustom";


const ReceiptPaper = ({ rcptData, sx }) => {
  const { RcptNm, RcptAddr, RcptTaxId, RcptBrchNo } = rcptData || {};
  return (
    <Paper sx={{ p: 2, width: 300, ...sx }}>
      <Typography variant="body2"><strong>ชื่อ: </strong> {RcptNm}</Typography>
      <Typography variant="body2"><strong>ที่อยู่: </strong> {RcptAddr}</Typography>
      <BoxFR>
        <Typography variant="body2"><strong>TAX ID: </strong>{RcptTaxId}</Typography>
        <Typography variant="body2">( {RcptBrchNo === 0 ? "สำนักงานใหญ่" : `สาขา: ${RcptBrchNo?.toString().padStart(5, "0")}`} )</Typography>
      </BoxFR>
    </Paper>
  )
}

export default ReceiptPaper;